import type { ProjectionLevel, SharedPerson } from './contracts'

export const sharedPeople: SharedPerson[] = [
  {
    id: 'you', grantedLevel: 'items', displayLevel: 'categories', stale: false,
    sync: 'Synced 4 minutes ago', since: '1 Jan 2026',
    projection: { level: 'items', displayName: 'You', score: 45, trails: [48, 41], accumulation: 9676, freshness: '2026-08-19T09:16:00Z', categories: [{ name: '3DVRS', earnedScore: 67 }, { name: 'Fuel', earnedScore: 25 }], successfulItems: ['Clear Notepad++', 'Meditation', 'Yakult', 'Beds made', 'Teeth'] },
  },
  {
    id: 'molly', grantedLevel: 'score', displayLevel: 'score', stale: false,
    sync: 'Synced 22 minutes ago', since: '1 Jan 2026',
    projection: { level: 'score', displayName: 'Molly', score: 92, trails: [89, 87], accumulation: 24180, freshness: '2026-08-19T08:58:00Z' },
  },
  {
    id: 'raf', grantedLevel: 'items', displayLevel: 'items', stale: false,
    sync: 'Synced 1 hour ago · London day', since: '14 Apr 2026',
    projection: { level: 'items', displayName: 'Raf', score: 64, trails: [68, 62], accumulation: 11205, freshness: '2026-08-19T08:20:00Z', categories: [{ name: 'Clarity', earnedScore: 71 }, { name: 'Fuel', earnedScore: 58 }], successfulItems: ['Morning review', 'Walk', 'Read'] },
  },
  {
    id: 'ben', grantedLevel: 'score', displayLevel: 'score', stale: true,
    sync: 'Last synced Tue 6:40pm', since: '2 Mar 2026',
    projection: { level: 'score', displayName: 'Ben', score: 77, trails: [74, 72], accumulation: 8940, freshness: '2026-08-18T08:40:00Z' },
  },
]

export type SharingRow = {
  id: string
  name: string
  youShare: ProjectionLevel | null
  sharedWithYou: ProjectionLevel | null
  incomingDisplay: ProjectionLevel | null
}

export const initialSharingRows: SharingRow[] = [
  { id: 'molly', name: 'Molly', youShare: 'items', sharedWithYou: 'score', incomingDisplay: 'score' },
  { id: 'raf', name: 'Raf', youShare: 'categories', sharedWithYou: 'items', incomingDisplay: 'items' },
  { id: 'ben', name: 'Ben', youShare: null, sharedWithYou: 'score', incomingDisplay: 'score' },
]
